import React, { Component } from 'react';
import { withFormik } from 'formik';
import Yup from 'yup';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

import FormikForm from '../../components/Form/FormikForm';
import TextInput from '../../components/Form/TextInputUX';
import TextInputTooltip from '../../components/Form/TextInputTooltip';
import GoogleRecaptcha from '../../components/Form/GoogleRecaptcha';
import ButtonWrapper from '../../components/Form/ButtonWrapper';
import Button from '../../collections/Button/Button';

import FaInfoCircle from 'react-icons/lib/fa/info-circle';
import ReactGA from 'react-ga';

// import { DisplayFormikState } from '../../utilities/utilities';

const SizedInfoCircle = styled(FaInfoCircle)`
  font-size: 1.5rem;
`;

class PinRetrievalForm extends Component {
  // constructor(props) {
  //   super(props);
  // };

  componentWillReceiveProps(nextProps) {
    let prompt = (this.props.isSubmitting === false && this.props.dirty === true);
    if (prompt !== this.props.form) {
      this.props.handleFormPrompt(prompt);
    }
  }

  sendEvent = (category, action, label) => {
      ReactGA.event({
          category: category,
          action: action,
          label: label
      })
  }

  render() {
    const {
      // values,
      // touched,
      errors,
      dirty,
      isSubmitting,
      // handleChange,
      // handleBlur,
      // handleSubmit,
      // handleReset,
      setFieldValue
    } = this.props;

    const sitekey = process.env.REACT_APP_GOOGLE_RECAPTCHA;
    // const prompt = (isSubmitting === false && dirty === true);

    this.sendEvent('CardActivation', 'Journey', 'PINRetrievalCardCredentials');

    return (
      <FormikForm>

        <TextInput name="name" type={this.props.appState.ui.pinRetrieval.formValidation.name.inputType} label={this.props.appState.ui.pinRetrieval.formValidation.name.label} placeholder={this.props.appState.ui.pinRetrieval.formValidation.name.placeholder}/>

        <TextInputTooltip 
          name="serialNumber"
          type={this.props.appState.ui.pinRetrieval.formValidation.serialNumber.inputType}
          label={this.props.appState.ui.pinRetrieval.formValidation.serialNumber.label} 
          placeholder={this.props.appState.ui.pinRetrieval.formValidation.serialNumber.placeholder} 
          icon={<SizedInfoCircle/>}
          companyLogo={this.props.appState.ui.pinRetrieval.tooltip.serialNumber.imageSrc}
          companyAlt={this.props.appState.ui.pinRetrieval.tooltip.serialNumber.imageAlt}
          // companyMessage={this.props.appState.ui.pinRetrieval.tooltip.serialNumber.message}
        />

        <GoogleRecaptcha sitekey={sitekey} data-size="compact" onChange={(response) => { setFieldValue("recaptcha", response); }}/>

        <ButtonWrapper>
          <Button 
            color={this.props.appState.ui.pinRetrieval.buttons.backward.textColor} 
            background={this.props.appState.ui.pinRetrieval.buttons.backward.backgroundColor} 
            border={this.props.appState.ui.pinRetrieval.buttons.backward.borderColor} 
            type="button"
            role="button"
            onClick={this.props.backHandler}>
            {this.props.appState.ui.pinRetrieval.buttons.backward.text}
          </Button>
          <Button 
            color={this.props.appState.ui.pinRetrieval.buttons.forward.textColor} 
            background={this.props.appState.ui.pinRetrieval.buttons.forward.backgroundColor}
            border={this.props.appState.ui.pinRetrieval.buttons.forward.borderColor} 
            type="submit" 
            role="button"
            disabled={isSubmitting || !isEmpty(errors) || !dirty}>
            {this.props.appState.ui.pinRetrieval.buttons.forward.text}
          </Button>
        </ButtonWrapper>

        {/* <DisplayFormikState {...props} /> */}
      </FormikForm>
    );
  }
};

const EnhancedForm = withFormik({
  mapPropsToValues: (props) => ({ 
    name: '',
    serialNumber: '',
    recaptcha: ''
  }),

  validationSchema: (props) => { return Yup.object().shape({
    name: Yup.string()
      .matches(new RegExp(props.appState.ui.pinRetrieval.formValidation.name.regex), props.appState.ui.pinRetrieval.formValidation.name.regexMessage)
      .required(props.appState.ui.pinRetrieval.formValidation.name.requiredMessage),
    serialNumber: Yup.string()
      .matches(new RegExp(props.appState.ui.pinRetrieval.formValidation.serialNumber.regex), props.appState.ui.pinRetrieval.formValidation.serialNumber.regexMessage)
      .min(props.appState.ui.pinRetrieval.formValidation.serialNumber.validLength, props.appState.ui.pinRetrieval.formValidation.serialNumber.validLengthMessage)
      .max(props.appState.ui.pinRetrieval.formValidation.serialNumber.validLength, props.appState.ui.pinRetrieval.formValidation.serialNumber.validLengthMessage)
      .required(props.appState.ui.pinRetrieval.formValidation.serialNumber.requiredMessage),
    recaptcha: Yup.string()
      .required()
  })},

  handleSubmit: (values, { props, setSubmitting, setStatus }) => {
    setSubmitting(true);
    props.update({loading: true});
    props.handleErrorMessage(false, '', `error`);
    props.api.getCheckCardDetails(values.serialNumber, values.name, null, 16)
      .then(response => {
        if (response !== null) {
          props.update({
            cardDetails: response,
            session: values
          }, (state) => {
            if (state.cardDetails.ExtranetSiteRuleId !== null) {
              props.api.getExtranetSiteRulesWithId(state.cardDetails.ExtranetSiteRuleId, 'en-gb')
                .then(response => {
                  let settings = response.Settings;
                  props.update({code: response.Code, 
                    ui: JSON.parse(settings[0].Value),
                    settings: {
                      culture: settings[0].CultureCode,
                      csskey: settings[1].Value,
                      emailTemplate: settings[2].Value,
                      emailPayload: settings[3].Value,
                      terms: settings[4].ResourceUrl
                      // terms: `${props.url === '/' ? window.location.origin + props.url +'terms' : window.location.origin + props.url + '/terms'}`
                    },
                    siteRules: response
                  }, (state) => {

                    let route = props.validateCodeAndReturnRoute(state.code);
                    if (state.cardDetails.ActivTransID === 6) {
                      switch (state.cardDetails.PpsAccountStatus) {
                        case 'I': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'A': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'S': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently suspended and therefore cannot be used.`, `error`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'pin-retrieval'))
                          })
                          break;
                        case 'B': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently blocked and therefore cannot be used.`, `error`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'pin-retrieval'))
                          })
                          break;
                        default:
                          props.handleCardStatus(state, route, setSubmitting)
                      }
                    } else {
                      setSubmitting(false);
                      props.handleErrorMessage(true, `Unfortunately, you can not retrieve your PIN. Please review the instructions sent to you with your card on how you can retrieve your PIN.`, `error`);
                      props.update({
                        route: {
                          schema: route.schema,
                          client: route.client,
                        },
                        loading: false
                      }, (state) => {
                        props.history.push(props.generateURIFromCode(state.code, 'pin-retrieval'))
                      })
                    }

                  });
                })
                .catch(error => {
                  setSubmitting(false);
                  props.update({loading: false});
                  props.handleErrorMessage(true, `Server responded with error: ${error}`, `error`);
                  // console.error('Server responded with error for getExtranetSiteRulesWithId', error);
                });
            } else {
              props.api.getExtranetSiteRulesWithId(1, 'en-gb')
                .then(response => {
                  let settings = response.Settings;
                  props.update({code: response.Code, 
                    ui: JSON.parse(settings[0].Value),
                    settings: {
                      culture: settings[0].CultureCode,
                      csskey: settings[1].Value,
                      emailTemplate: settings[2].Value,
                      emailPayload: settings[3].Value,
                      terms: settings[4].ResourceUrl
                      // terms: `${props.url === '/' ? window.location.origin + props.url +'terms' : window.location.origin + props.url + '/terms'}`
                    },
                    siteRules: response
                  }, (state) => {
                    let route = props.validateCodeAndReturnRoute(state.code);
                    if (state.cardDetails.ActivTransID === 6) {
                      switch (state.cardDetails.PpsAccountStatus) {
                        case 'I': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'A': 
                          props.handleCardStatus(state, route, setSubmitting)
                          break;
                        case 'S': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently suspended and therefore cannot be used.`, `error`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'pin-retrieval'))
                          })
                          break;
                        case 'B': 
                          setSubmitting(false);
                          props.handleErrorMessage(true, `Your card is currently blocked and therefore cannot be used.`, `error`);
                          props.update({
                            route: {
                              schema: route.schema,
                              client: route.client,
                            },
                            loading: false
                          }, (state) => {
                            props.history.push(props.generateURIFromCode(state.code, 'pin-retrieval'))
                          })
                          break;
                        default:
                          props.handleCardStatus(state, route, setSubmitting)
                      }
                    } else {
                      setSubmitting(false);
                      props.handleErrorMessage(true, `Unfortunately, you can not retrieve your PIN. Please review the instructions sent to you with your card on how you can retrieve your PIN.`, `error`);
                      props.update({
                        route: {
                          schema: route.schema,
                          client: route.client,
                        },
                        loading: false
                      }, (state) => {
                        props.history.push(props.generateURIFromCode(state.code, 'pin-retrieval'))
                      })
                    }
                  });
                })
                .catch(error => {
                  setSubmitting(false);
                  props.handleErrorMessage(true, `Server responded with error: ${error}`, `error`);
                  // console.error('Server responded with error for getExtranetSiteRulesWithId', error);
                });
            }
          });
        } else {
          setSubmitting(false);
          props.update({session: values, loading: false})
          if (props.attempts < 3) {
            props.handleMultipleAttempts();
            props.handleErrorMessage(true, `The name or card serial number does not match what we have, please re-enter.`, `error`);
          } else {
            props.handleErrorMessage(true, `You have attempted to provide a card serial number unsuccessfully three times or more. The serial number can be found on the back of the card in the top right hand corner starting with the number 8.`, `error`);
          }
          // console.error('Server responded with null', response);
        }
      })
      .catch(error => {
        setSubmitting(false);
        props.update({loading: false});
        props.handleErrorMessage(true, `Server responded with error: ${error}`, `error`);
        // console.error('Server responded with error', error);
      });
  },

  displayName: 'PinRetrievalStep1', // helps with React DevTools
})(PinRetrievalForm);


export default EnhancedForm;


// WEBPACK FOOTER //
// ./src/containers/PinRetrievalPage/Step1.js